import { AsyncPipe } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { IonRouterOutlet, IonToast } from '@ionic/angular/standalone'

import { SessionTimeoutService } from '../../shared/services/session-timeout.service'
import { WebsocketService } from '../../shared/services/websocket.service'
import { AuthenticatedLayoutService } from './authenticated-layout.service'

@Component({
	selector: 'app-authenticated-layout',
	templateUrl: './authenticated-layout.component.html',
	standalone: true,
	imports: [IonRouterOutlet, AsyncPipe, IonToast],
})
export class AuthenticatedLayoutComponent implements OnInit {
	constructor(
		private readonly authenticatedLayoutService: AuthenticatedLayoutService,
		private readonly sessionTimeoutService: SessionTimeoutService,
		readonly websocketService: WebsocketService,
	) {}

	ngOnInit() {
		this.authenticatedLayoutService.initializeApp()
		this.sessionTimeoutService.setupSessionTimeout()
	}
}
